(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    (window.extendedWarrantyConfig || []).forEach(setupInstance);
  }

  // --- Shared details modal, fully self-contained with unique
  // class/attribute names so it cannot collide with the theme's own
  // modal system or any other script on the page (e.g. Ymq,
  // QuickCart) — same pattern as antenna-upgrade-selector's image
  // modal. Built once and reused for every instance of this widget on
  // the page. ---
  var modalEl = null;
  var modalImageEl = null;
  var modalTriggerEl = null; // element to restore focus to on close

  function getModal() {
    if (modalEl) return modalEl;

    modalEl = document.createElement('div');
    modalEl.className = 'warranty-details-modal';
    modalEl.setAttribute('data-warranty-details-modal', '');

    var backdrop = document.createElement('div');
    backdrop.className = 'warranty-details-modal__backdrop';
    backdrop.addEventListener('click', closeModal);

    var dialog = document.createElement('div');
    dialog.className = 'warranty-details-modal__dialog';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-label', 'Extended warranty details');

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'warranty-details-modal__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.textContent = '\u00D7'; // ×
    closeBtn.addEventListener('click', closeModal);

    modalImageEl = document.createElement('img');
    modalImageEl.className = 'warranty-details-modal__image';
    modalImageEl.alt = 'Extended warranty details';

    dialog.appendChild(closeBtn);
    dialog.appendChild(modalImageEl);
    modalEl.appendChild(backdrop);
    modalEl.appendChild(dialog);
    document.body.appendChild(modalEl);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modalEl.classList.contains('warranty-details-modal--visible')) {
        closeModal();
      }
    });

    return modalEl;
  }

  function openModal(imageUrl, triggerEl) {
    var modal = getModal();
    modalImageEl.src = imageUrl;
    modal.classList.add('warranty-details-modal--visible');
    document.body.classList.add('warranty-details-modal-open');
    modalTriggerEl = triggerEl || null;

    var closeBtn = modal.querySelector('.warranty-details-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    if (!modalEl || !modalEl.classList.contains('warranty-details-modal--visible')) return;
    modalEl.classList.remove('warranty-details-modal--visible');
    document.body.classList.remove('warranty-details-modal-open');
    if (modalTriggerEl && typeof modalTriggerEl.focus === 'function') {
      modalTriggerEl.focus();
    }
    modalTriggerEl = null;
  }
  // --- End shared details modal ---

  function setupInstance(config) {
    var root = document.querySelector(config.rootSelector);
    if (!root) return;

    if (!window.ProductAddonsCore) {
      console.error('extended-warranty-addon: ProductAddonsCore not found — make sure product-addons-core.js loads first');
      return;
    }

    var chipGroup = root.querySelector('[data-extended-warranty-chip-group]');
    var errorEl = root.querySelector('[data-extended-warranty-error]');
    var detailsTrigger = root.querySelector('[data-extended-warranty-details-trigger]');
    var detailsImageUrl = config.detailsImageUrl || '';
    var variants = config.variants || [];
    var selectedSkus = {}; // sku -> true, nothing selected by default

    if (detailsTrigger) {
      if (detailsImageUrl) {
        detailsTrigger.addEventListener('click', function () {
          openModal(detailsImageUrl, detailsTrigger);
        });
      } else {
        // No image configured — don't wire up a click that would open
        // an empty modal; fail loudly in the console instead.
        console.error('extended-warranty-addon: detailsImageUrl is not set — check the details_image_url assign in extended-warranty-addon.liquid');
      }
    }

    if (!variants.length) {
      showError('Extended warranty options are not configured correctly. Contact support.');
      console.error('extended-warranty-addon: no variants resolved — check the addon_handle in product-form.liquid matches the real product handle');
      // Register anyway so this fails loudly instead of silently
      // shipping without any extended warranty options at all.
      window.ProductAddonsCore.register(root, function () {
        showError('Extended warranty options are not configured correctly. Contact support.');
        return { ok: false };
      });
      return;
    }

    renderChips();
    window.ProductAddonsCore.register(root, getContribution, getPriceContribution);

    function renderChips() {
      chipGroup.innerHTML = '';
      variants.forEach(function (variant) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'product__chip';
        chip.dataset.sku = variant.sku;
        chip.setAttribute('aria-pressed', 'false');
        chip.textContent = chipLabel(variant);
        chip.addEventListener('click', function () {
          var isNowSelected = !selectedSkus[variant.sku];
          if (isNowSelected) {
            selectedSkus[variant.sku] = true;
          } else {
            delete selectedSkus[variant.sku];
          }
          chip.classList.toggle('selected', isNowSelected);
          chip.setAttribute('aria-pressed', isNowSelected ? 'true' : 'false');
          clearError();
          if (window.ProductAddonsCore.notifyChange) window.ProductAddonsCore.notifyChange(root);
        });
        chipGroup.appendChild(chip);
      });
    }

    // Live price preview only — no validation, no error UI.
    function getPriceContribution() {
      var total = 0;
      variants.forEach(function (v) {
        if (selectedSkus[v.sku]) total += Number(v.price);
      });
      return total;
    }

    function chipLabel(variant) {
      var name = (variant.label && variant.label !== 'Default Title') ? variant.label : variant.sku;
      return name + ' (+' + formatMoney(variant.price) + ')';
    }

    // Called by ProductAddonsCore when the shopper clicks add-to-cart.
    // Always ok: this option is entirely optional, zero selections is valid.
    function getContribution() {
      var items = variants
        .filter(function (v) { return selectedSkus[v.sku]; })
        .map(function (v) {
          return {
            id: v.variantId,
            quantity: 1,
            properties: { 'Extended Warranty': v.label || v.sku }
          };
        });

      clearError();
      return { ok: true, items: items };
    }

    function showError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }
    function clearError() { errorEl.textContent = ''; errorEl.hidden = true; }
    function formatMoney(amount) { return '$' + Number(amount).toFixed(2); }
  }
})();